import { pick } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSocketSelector } from 'js/store/hooks';
import { useGetClientIP } from 'server';

import * as actions from '../store/actions';

export const useClientIP = () => {
    const dispatch = useDispatch();
    const getClientIP = useGetClientIP();
    const { connected, isError } = useSocketSelector(pick(['connected', 'isError']));

    useEffect(() => {
        if (isError) {
            dispatch(actions.setClientIP(''));

            return;
        }

        if (!connected) {
            return;
        }

        (async () => {
            try {
                const { clientIp = '' } = await getClientIP();

                dispatch(actions.setClientIP(clientIp));
            } catch {
                dispatch(actions.setClientIP(''));
            }
        })();
    }, [
        connected,
        dispatch,
        getClientIP,
        isError
    ]);
};
